import {
  getToken,
  getUser,
  setUserSessionRefresh,
  cerrarSession,
  getTokenRefresh,
} from "utils/Common";
import endpoints from "utils/services/EndPoints";

export default async function Api(
  url,
  method = "GET",
  bodyParam,
  token,
  tokenRefresh = ""
) {
  let errorSW, data;
  let bodyParametro = null;
  const arrayErrores = mensajes();
  try {
    if (bodyParam != null) {
      bodyParametro = JSON.stringify(bodyParam);
    }

    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };

    if (token === null || token === undefined) {
      token = `${getToken()}`;
      tokenRefresh = `${getTokenRefresh()}`;
    }

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const request = {
      method: method,
      headers: headers,
      body: bodyParametro,
    };
    const res = await fetch(url, request);

    data = await res.json();
    if (res.status < 200 || res.status >= 300) {
      if (res.status === 403 && token && url !== endpoints.JWTRefresh) {
        const datosUsuario = getUser();
        let usuario = {
          username: getUser().username,
        };

        const tokenData = await Api(
          endpoints.JWTRefresh,
          "POST",
          usuario,
          tokenRefresh,
          null
        );
        const newData = await Api(
          url,
          method,
          bodyParam,
          tokenData.token,
          tokenData.tokenRefresh
        );
        newData.newToken = tokenData.token;
        newData.newTokenRefresh = tokenData.tokenRefresh;

        setUserSessionRefresh(
          datosUsuario,
          tokenData.token,
          tokenData.tokenRefresh
        );
        return newData;
      }

      let estado = data.estado;
      if (data.estado === null) {
        estado = res.status;
      }
      if (url === endpoints.JWTRefresh && res.status === 403) {
        estado = -100;
      }
      errorSW = generaError(
        validarMensaje(data.mensaje, url),
        estado,
        res,
        res.status
      );
      if (estado === -100) {
        cerrarSession();
      }
    }
  } catch (error) {
    if (error.code === -100) {
      cerrarSession();
      errorSW = generaError("Su sesión ha expirado", "expired_session");
    } else {
      let mensajeError = "";
      if (error.message) {
        arrayErrores.forEach((element) => {
          if (
            error.message.includes(element["message"]) ||
            error.message === element["message"]
          ) {
            mensajeError = element["mensaje"];
          }
        });
      } else {
        mensajeError = arrayErrores[0]["mensaje"];
      }
      let detError = mensajeError;
      if (mensajeError === "") {
        detError = error.message;
      }
      errorSW = generaError(
        detError === "" ? error.message : detError,
        "network_error"
      );
    }
  }
  if (!errorSW) {
    return data;
  }
  throw errorSW;
}

//******* GENERA ERROR
const generaError = (mensaje, code, res, status) => {
  let errorSW;
  errorSW = new Error(
    mensaje
      ? mensaje
      : "Se ha generado un error en el sistema, notifique al administrador"
  );
  errorSW.res = res ? res : null;
  errorSW.status = status ? status : null;
  errorSW.code = code ? code : null;
  return errorSW;
};

//******* VALIDA MENSAJES
const validarMensaje = (mensajeSW, url) => {
  let unexError = `Unexpected Error (${url})`;
  if (mensajeSW != null) {
    unexError = mensajeSW.replace(/<br>/g, ". ").replace(/<br\/>/g, ". ");
  }
  var mensaje = unexError;
  return mensaje;
};

//******* MENSAJES DE ERROR
const mensajes = () => {
  const arrayErrores = [
    {
      message: "Unexpected end of JSON input",
      mensaje: "Error de la red, por favor verifique la conexión",
    },
    {
      message: "Failed to fetch",
      mensaje: "Error de la red, por favor verifique la conexión",
    },
    {
      message: "Network request failed",
      mensaje: "Error de la red, por favor verifique la conexión",
    },
    {
      message: "Unexpected token",
      mensaje: "Se produjo un error al realizar la operación",
    },
    {
      message: "Unrecognized token",
      mensaje:
        "Se produjo un error al realizar la operación, verifique la conexión",
    },
  ];
  return arrayErrores;
};
